import React, { useState } from "react";
import moment from "moment";
import { Form, Button, Collapse, ButtonGroup, ToggleButton } from "react-bootstrap";
import Select from "../../components/Select";
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";
import "moment/locale/he";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const TimeRanges = {
  LAST_SIX_MONTHS: "LAST_SIX_MONTHS",
  LAST_YEAR: "LAST_YEAR",
  LAST_TWO_YEARS: "LAST_TWO_YEARS",
  CUSTOM: "CUSTOM"
};

const ArchiveMobileSearchForm = ({ startTime, endTime, searchCallback, lookups, orderByAmount, totalSearchAmount }) => {
  const [customStartTime, setCustomStartTime] = useState(startTime ? moment(startTime) : moment().startOf("month"));
  const [customEndTime, setCustomEndTime] = useState(endTime ? moment(endTime) : moment().endOf("month"));
  const [text, setText] = useState("");
  const [tags, setTags] = useState([]);
  const [categories, setCategories] = useState([]);
  const [open, setOpen] = useState(true);
  const [selectedTimeRange, setSelectedTimeRange] = useState(TimeRanges.LAST_SIX_MONTHS);
  const [approvedOnly, setApprovedOnly] = useState(false);
  const [showCustomTimeRange, setShowCustomTimeRange] = useState(false);

  const parseTime = () => {
    let start = customStartTime;
    if (selectedTimeRange === TimeRanges.LAST_SIX_MONTHS) {
      start = moment().subtract(6, "month").toDate();
    } else if (selectedTimeRange === TimeRanges.LAST_YEAR) {
      start = moment().subtract(1, "year").toDate();
    } else if (selectedTimeRange === TimeRanges.LAST_TWO_YEARS) {
      start = moment().subtract(2, "year").toDate();
    }
    return { startTime: start, endTime: customEndTime };
  };

  const handleSearch = () => {
    const { startTime, endTime } = parseTime();
    searchCallback({ startTime, endTime, text, tags, categories, approvedOnly });
    setOpen(false);
  };

  const cardStyle = {
    background: "white",
    margin: "30px",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    borderRadius: "10px"
  };
  return (
    <div>
      <div style={{ direction: "rtl", display: "flex", justifyContent: "center" }}>
        <div style={cardStyle}>
          <div style={{ width: "300px", margin: "10px" }}>
            <b style={{ margin: "10px" }}>חיפוש</b>
            {open ? (
              <FaChevronUp style={{ width: "50px" }} onClick={() => setOpen(false)} />
            ) : (
              <FaChevronDown style={{ width: "50px" }} onClick={() => setOpen(true)} />
            )}
          </div>
          <Collapse in={open}>
            <div style={{ margin: "20px" }}>
              <Form.Group className="mb-3">
                <div dir="rtl">
                  <ButtonGroup style={{ margin: "10px" }}>
                    <ToggleButton
                      style={{ marginRight: "10px" }}
                      id="radio-0"
                      type="radio"
                      variant="outline-primary"
                      value={TimeRanges.LAST_SIX_MONTHS}
                      checked={selectedTimeRange === TimeRanges.LAST_SIX_MONTHS}
                      onClick={() => setShowCustomTimeRange(false)}
                      onChange={() => setSelectedTimeRange(TimeRanges.LAST_SIX_MONTHS)}
                    >
                      6 חודשים
                    </ToggleButton>
                    <ToggleButton
                      style={{ marginRight: "10px" }}
                      id="radio-1"
                      type="radio"
                      variant="outline-primary"
                      value={TimeRanges.LAST_YEAR}
                      checked={selectedTimeRange === TimeRanges.LAST_YEAR}
                      onClick={() => setShowCustomTimeRange(false)}
                      onChange={() => setSelectedTimeRange(TimeRanges.LAST_YEAR)}
                    >
                      שנה
                    </ToggleButton>
                    <ToggleButton
                      style={{ marginRight: "10px" }}
                      id="radio-2"
                      type="radio"
                      variant="outline-primary"
                      value={TimeRanges.LAST_YEAR}
                      checked={selectedTimeRange === TimeRanges.LAST_TWO_YEARS}
                      onClick={() => setShowCustomTimeRange(false)}
                      onChange={() => setSelectedTimeRange(TimeRanges.LAST_TWO_YEARS)}
                    >
                      שנתיים
                    </ToggleButton>
                    <ToggleButton
                      style={{ marginRight: "10px" }}
                      id="radio-3"
                      type="radio"
                      variant="outline-primary"
                      value={TimeRanges.CUSTOM}
                      checked={selectedTimeRange === TimeRanges.CUSTOM}
                      onClick={() => setShowCustomTimeRange(true)}
                      onChange={() => setSelectedTimeRange(TimeRanges.CUSTOM)}
                    >
                      טווח
                    </ToggleButton>
                  </ButtonGroup>
                </div>
              </Form.Group>

              {true && (
                <>
                  <Form.Group className="mb-3">
                    <Form.Label>תאריך התחלה</Form.Label>
                    <Datetime
                      locale="he"
                      dateFormat="DD-MM-YYYY"
                      timeFormat={false}
                      closeOnSelect
                      value={customStartTime}
                      onChange={setCustomStartTime}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>תאריך סיום</Form.Label>
                    <Datetime
                      locale="he"
                      dateFormat="DD-MM-YYYY"
                      timeFormat={false}
                      closeOnSelect
                      value={customEndTime}
                      onChange={setCustomEndTime}
                    />
                  </Form.Group>
                </>
              )}

              <Form.Group className="mb-3">
                <Form.Label>קטגוריות</Form.Label>
                <Select
                  options={lookups.categories}
                  multi
                  onSelect={setCategories}
                  placeholder="קטגוריות"
                  isSearchable={false}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>תגיות</Form.Label>
                <Select
                  options={lookups.tags}
                  multi
                  onSelect={setTags}
                  placeholder="תגיות"
                  isSearchable={false}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>טקסט</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="טקסט לחיפוש"
                  onChange={(e) => setText(e.target.value)}
                />
              </Form.Group>

              <div style={{ marginBottom: "20px" }}>
                <input
                  style={{ marginLeft: "10px" }}
                  type="checkbox"
                  className="form-check-input"
                  id="approvedCheck"
                  onChange={(e) => setApprovedOnly(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="approvedCheck">
                  הצג פעולות שאושרו בלבד
                </label>
              </div>

              <Button
                style={{
                  background: "rgb(255, 102, 102)",
                  borderRadius: "17px",
                  borderColor: "rgb(255, 102, 102)"
                }}
                variant="primary"
                type="submit"
                onClick={handleSearch}
              >
                חפש
              </Button>
              <Button
                style={{
                  marginRight: "20px",
                  background: "rgb(255, 102, 102)",
                  borderRadius: "17px",
                  borderColor: "rgb(255, 102, 102)"
                }}
                variant="primary"
                type="submit"
                onClick={orderByAmount}
              >
                מיין
              </Button>

              <div style={{ marginTop: "20px" }}>
                סה״כ סכום כולל בחיפוש: {totalSearchAmount}
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default ArchiveMobileSearchForm;